import { render, staticRenderFns } from "./VAnimatedNumber.vue?vue&type=template&id=66a81613&scoped=true"
import script from "./VAnimatedNumber.vue?vue&type=script&lang=js"
export * from "./VAnimatedNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a81613",
  null
  
)

export default component.exports